const ImagePreview = ({
  url,
  alt_text,
}: {
  url: string;
  alt_text?: string;
}) => {
  return (
    <a href={url} target="_blank">
      <img
        alt={alt_text ?? "aichat-media"}
        src={url}
        className="w-full object-cover rounded-xl"
      />
    </a>
  );
};

export default ImagePreview;
